import { RouteObject } from "react-router";
import { setupMakePaymentRoutes } from "src/router/routes/common/MakePayment";
import { SigningRoute, VoidSignedDocumentRoute } from "src/router/routes/jobs/Signatures";

export const ContractsRoutes: RouteObject[] = [
  {
    path: ":estimateId",
    async loader(args) {
      const { contractLoader } = await import("src/router/loaders/jobs/Estimates");
      return contractLoader(args);
    },
    async lazy() {
      const { ContractDocsList } = await import("jobs/Job/ContractsTab/ContractDocsList");
      return { element: <ContractDocsList /> };
    },

    children: [
      SigningRoute,
      VoidSignedDocumentRoute,
      {
        path: "email",
        async lazy() {
          const { EmailEstimate } = await import("jobs/components/EmailEstimate");
          return { element: <EmailEstimate docType="contract" /> };
        },
      },
      ...setupMakePaymentRoutes(),
    ],
  },
  {
    path: ":estimateId/view_pdf/:documentId",
    shouldRevalidate: ({ currentParams, nextParams }) => currentParams.estimateId !== nextParams.estimateId,
    async loader(args) {
      const { contractPdfViewLoader } = await import("src/router/loaders/jobs/Estimates");
      return contractPdfViewLoader(args);
    },
    async lazy() {
      const { ViewContractDoc } = await import("jobs/Job/ContractsTab/ViewContractDoc");
      return {
        element: <ViewContractDoc />,
      };
    },
    children: [
      {
        path: "email",
        async lazy() {
          const { EmailEstimate } = await import("jobs/components/EmailEstimate");
          return {
            element: <EmailEstimate docType="contract" />,
          };
        },
      },
      {
        path: "signature",
        // No `shouldRevalidate` on purpose: on direct entry/refresh the loader regenerates + validates
        // the PDF for a new contract, or re-validates the persisted one for a saved contract, rather
        // than risk serving a stale one. The in-modal flow fires no router actions, so this loader only
        // re-runs on real navigation — bounded, low-risk cost.
        async loader(args) {
          const { contractSignatureLoader } = await import("src/router/loaders/jobs/Estimates");
          return contractSignatureLoader(args);
        },
        async lazy() {
          const { ContractSignature } = await import("jobs/Job/ContractsTab/ContractSignature");
          return { element: <ContractSignature /> };
        },
      },
      ...setupMakePaymentRoutes(),
    ],
  },
  {
    path: "",
    async loader(args) {
      const { contractsLoader } = await import("src/router/loaders/jobs/Estimates");
      return contractsLoader(args);
    },
    async lazy() {
      const { ContractsTab } = await import("jobs/Job/ContractsTab");
      return { element: <ContractsTab /> };
    },
  },
  ...setupMakePaymentRoutes(),
];
